// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"242":"5b3ac2c82003d1c1","977":"792f2fa619ac0d1e"}[chunkId] + ".js";
};